import { useNavigate } from "react-router-dom";
import Button from "../../../views/buttons/Button";
import { DropZone } from "../../../views/dropzone/DropZone";
import InputTextField from "../../../views/inputfield/InputTextField";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useEffect, useState } from "react";
import wbApi from "../../../API/wbApi";
import { toast } from "react-toastify";
import { Capitalize, CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import { getAllHotelsAndOffers } from "../../../redux/actions/OffersAction";
import { nanoid } from "@reduxjs/toolkit";
import { getAllHotelsAndFacility } from "../../../redux/actions/FacilityAction";
import DropzoneArea from "../../../views/customDropzone/DropzoneArea";
import CardWrapper from "../../../views/datacard/CardWrapper";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { ShowConfirmationPrompt, CancelConfirmationPrompt } from "../../../redux/actions/PromptAction";

const EditFacility = () => {
  // Data from Redux
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const updateFacility = useSelector(
    (state: RootState) => state.facilityUpdate
  );
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [title, setTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [facilitySectId, setFacilitySectId] = useState("");
  const [description, setDescription] = useState<any>("");
  const [facilityArr, setFacilityArr] = useState([]);
  const [hotelsArr, setHotelsArr] = useState([]);
  const [charCount, setCharCount] = useState({
    child: 0,
    privacy: 0,
    terms_cond: 0,
    cancellation: 0,
  });
  const [facilityBannerImg, setFacilityBannerImg] = useState<any>();
  const [facilitySectionDetails, setFacilitySectionDetails] = useState<any>([]);
  const [facilityFile, setFacilityFile] = useState<any[]>([]);
  const [refreshList, setRefreshList] = useState<boolean>(false);

  const [update, setUpdate] = useState("");

  const dispatch = useDispatch();

  function removeTags(str: String) {
    str = str.toString();
    const finalStr = str.replace(/&nbsp;/g, " ");
    return finalStr.replace(/(<([^>]+)>)/gi, ""); // Regular expression to identify HTML tags in the input string. Replacing the identified,HTML tag with a null string.
  }

  const getFacilityDataApi = async () => {
    try {
      const resp = await wbApi.get(
        `wb-dashboard/fetch-wb-facilities-section-details/${company_id}/${template_id}/10`
      );
      if (resp.data.status === 1) {
        setFacilityArr(resp?.data?.hotel_facilities);
        setTitle(resp?.data?.facility_section_details?.section_title);
        setDescription(resp?.data?.facility_section_details?.section_description ?? "");
        setAltText(resp?.data?.facility_section_details?.background_image_alt);
        setFacilitySectId(resp?.data?.facility_section_details?.id);
        setHotelsArr(resp?.data?.all_hotels_data);
        if (resp?.data?.facility_section_details?.background_image) {
          setFacilityBannerImg([
            getImage(resp?.data?.facility_section_details?.background_image),
          ]);
        } else {
          setFacilityBannerImg([]);
        }
        setFacilitySectionDetails(resp?.data?.facility_section_details);
      } else {
        setFacilityArr([]);
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  useEffect(() => {
    getFacilityDataApi();
  }, [update, updateFacility]);

  const postFacilitySectDataApi = async (imgId: any) => {
    setLoader(true);
    try {
      const payload = {
        background_image: imgId ?? "undefined",
        background_image_alt: altText,
        company_id: company_id,
        id: facilitySectId ?? "undefined",
        section_description: description,
        section_id: defaultSectionId,
        section_title: title,
        template_id: template_id,
      };
      const resp = await wbApi.post(
        `wb/insert-update-default-section-details`,
        payload
      );

      if (resp.data.status === 1) {
        toast.success(resp.data.message);
        setUpdate(nanoid());
        setLoader(false);
        setRefreshList(!refreshList)
      } else {
        toast.error(resp.data.message)
        setLoader(false);
      };
    } catch {
      toast.error(CATCH_MESSAGE);
      setLoader(false);
    }
  };

  // DropZoneHandler
  const accpFacilityFiles = (value: any) => {
    setFacilityFile(value);
  };

  const deleteFacilityFiles = (value: any) => {
    if (value) {

      dispatch(
        ShowConfirmationPrompt(
          `Are you sure want to delete this ?`,
          "DELETE",
          async () => {
            await delteFacilityFilesApi();

            dispatch(CancelConfirmationPrompt());
          }
        )
      );
    }
  };

  const delteFacilityFilesApi = async () => {
    try {
      let deleteRes = await wbApi.post(
        `/wb/delete-dz-default-section-background-image`,
        {
          company_id: company_id,
          image_name: facilitySectionDetails.background_image,
          section_id: defaultSectionId,
          template_id: template_id,
        }
      );
      // console.log("deleteRes", deleteRes);
      if (deleteRes.data.status === 1) {
        toast.success(deleteRes.data.message);
        getFacilityDataApi();
      } else {
        toast.error(deleteRes.data.message);
        getFacilityDataApi();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  // Save Handler
  const saveHandler = async () => {
    if (facilityFile.length) {
      uploadHandler();
    } else {
      postFacilitySectDataApi("undefined");
    }
  };

  // Image uploader handler
  const uploadHandler = async () => {

    if (facilityFile.length === 1) {
      let payload = new FormData();
      payload.append("uploadFile[0]", facilityFile[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/insert-dz-images/${company_id}/${template_id}/facility_background_image`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        if (uploadRes.data.status === 1) {
          toast.success(uploadRes.data.message);
          await postFacilitySectDataApi(uploadRes.data.image_ids);
        } else {
          toast.error(uploadRes.data.message);
        }
      } catch {
        toast.error(CATCH_MESSAGE);
      }
    } else {
      toast.error("Only One Image Allowed");
    }
  };

  return (
    <>
      <div className="wb-subheader">
        <CustomBreadcrumbs
          content={[
            {
              label: "Sections",
              href: "/section-default",
            },
            {
              label: `Default Section`,
              href: "/section-default",
            },
            {
              label: "Edit Facilites",
            }
          ]}
        />
        <div className="wb-subheader-rightsec">
          <Button
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
      </div>
      <div className="wb-divider"></div>

      {/*------------------- Main Section----------------- */}
      <CardWrapper className=" mt-4 mb-4 edit-promo-conatiner">
        <div className="edit-aboutus-text-container">
          <InputTextField
            label="Enter Title"
            value={title}
            className="edit-aboutus-subheader"
            handleChange={(e) => {
              setTitle(e.target.value);
            }}
          />
          <InputTextField
            label="Alternate Text"
            value={altText}
            className="edit-aboutus-alt-text"
            handleChange={(e) => {
              setAltText(e.target.value);
            }}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Select Back Ground Image
        </div>

        <div className="edit__dropzone__container">
          <DropzoneArea
            centerMesage={"Drag your photos or click here (1 Image Only)"}
            incomingfiles={facilityBannerImg}
            dispatchFiles={(val) => accpFacilityFiles(val)}
            isDelete={(val) => deleteFacilityFiles(val)}
            acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
            refresh={refreshList}
          />
        </div>

        <div
          className="sec-description-editor"
          style={{ margin: "1.5rem 0rem" }}
        >
          <div className="">
            <CKEditor
              editor={ClassicEditor}
              data={description}
              config={{
                removePlugins: [
                  "EasyImage",
                  "ImageUpload",
                  "MediaEmbed",
                  "Table",
                ],
              }}
              onChange={(event: string, editor: any) => {
                const data = editor.getData();
                setDescription(data);
                setCharCount({
                  ...charCount,
                  terms_cond: removeTags(data).length,
                });
              }}
            />
          </div>
        </div>

        <div className="edit-contact-btn-container">
          <Button className="cancel__btn" handleClick={() => navigate(-1)}>Cancel</Button>
          <Button className="savebtn"
            handleClick={() => saveHandler()}
            loader={loader}
          >
            Save
          </Button>
        </div>
      </CardWrapper>

      {hotelsArr?.length > 0 ? (
        <div className="select__hotel__label">Select Hotels</div>
      ) : (
        <></>
      )}

      <div className="default_section_image_card_container mt-3">
        {hotelsArr?.length > 0 ? (
          hotelsArr?.map((obj, ind) => {
            const { hotel_id, hotel_name, hotel_image } = obj ?? {};
            return (
              <div
                key={ind}
                className="default__setion__image"
                onClick={() => {
                  dispatch(
                    getAllHotelsAndFacility({
                      hotel_id,
                      hotel_name,
                      facilityArr,
                    })
                  );
                  navigate("edit-hotel-facilites");
                }}
              >
                <div className="image__container">
                  {
                    hotel_image ? (
                      <img
                        src={hotel_image}
                        alt={hotel_name}
                        className="default__setion__image__image"
                      />
                    ) : (
                      <div className="image_container_icon_wrapper">
                        <FontAwesomeIcon icon={Icons.faHotel} size="2x" color="blue" />
                      </div>

                    )
                  }
                  <div className="hotel__name">{Capitalize(hotel_name)}</div>
                </div>
              </div>
            )
          })
        ) : (
          <NoDataComponent message="No Hotels Found" />
        )}
      </div>
    </>
  );
};

export default EditFacility;
